import { isNullOrWhitespace } from '@functions/is-null-or-whitespace';
import { UserLangUtils } from '@utils/user-lang-utils';

export function parseNumberWithThousandSeparator(value: string, locales: string[] | null): number | null {
  if (isNullOrWhitespace(value)) {
    return null;
  }

  const directParse = parseFloat(value);

  if (!isNaN(directParse) && isDirectMatch(value, directParse)) {
    return directParse;
  }

  if (locales == null || locales.length === 0) {
    locales = UserLangUtils.getUserLanguages();
  }

  const separators = UserLangUtils.getLocaleSeparators(locales[0]);
  const cleanedValue = value.replace(separators.thousand, '');
  const normalized = cleanedValue.replace(separators.decimal, '.');

  return parseFloat(normalized);
}

function isDirectMatch(original: string, parsed: number): boolean {
  const precision = original.split('.')[1]?.length || 0;
  return parsed.toFixed(precision) === original;
}